var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "section__title animated-title",
    class: {
      'animating': _vm.pageReady
    }
  }, [_c('PageTitleContent', {
    attrs: {
      "isActive": _vm.isActive,
      "titleValue": _vm.titleValue
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eae867dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageTitle.vue
// module id = 212
// module chunks = 0